module.exports = __webpack_public_path__ + "img/emoji-24.f9dc2266.png";